var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4994 8.16666H19.8327V14C19.8327 16.8827 20.0538 17.5 20.9994 17.5C22.521 17.5 23.3327 16.7804 23.3327 14C23.3327 7.82909 20.2376 4.66666 13.9996 4.66666C9.95815 4.66718 6.37623 7.26863 5.12555 11.1116C3.87487 14.9546 5.23962 19.166 8.5066 21.5449C11.7736 23.9239 16.2005 23.93 19.4741 21.56L20.8424 23.45C16.7505 26.4125 11.2168 26.4049 7.13308 23.4312C3.04934 20.4574 1.34342 15.1933 2.90676 10.3895C4.47011 5.5858 8.94752 2.33396 13.9994 2.33333C21.5377 2.33333 25.666 6.55153 25.666 14C25.666 18.1357 23.7514 19.8333 20.9994 19.8333C19.4316 19.8333 18.5343 19.3278 18.0417 18.2056C16.9933 19.2136 15.5686 19.8333 13.9994 19.8333C10.7777 19.8333 8.16606 17.2216 8.16606 14C8.16606 10.7783 10.7777 8.16666 13.9994 8.16666C15.3126 8.16666 16.5245 8.60059 17.4994 9.3329V8.16666ZM17.4994 14C17.4994 15.933 15.9324 17.5 13.9994 17.5C12.0664 17.5 10.4994 15.933 10.4994 14C10.4994 12.0669 12.0664 10.5 13.9994 10.5C15.9324 10.5 17.4994 12.0669 17.4994 14Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtSign);
export default __webpack_public_path__ + "static/media/at-sign.6436263e.svg";
export { ForwardRef as ReactComponent };